export const ageDropDown = [
    "Under 18, legally emancipated",
    "Under 18, not emancipated",
    "18-24",
    "25 and older"
];

export const nycAgeDropDown = [
    "16-17",
    "18-24",
    "25 and older"
];

export const genderOption: any = [
    {
        label: "Male",
        value: "Male"
    },
    {
        label: "Female",
        value: "Female"
    },
    {
        label: "Trans male",
        value: "Trans-male"
    },
    {
        label: "Trans female",
        value: "Trans-female"
    },
    {
        label: "Non-binary",
        value: "Non-binary"
    },
    {
        label: "Other",
        value: "Other"
    },
];

export const accompanyingChildren: any = [
    {
        label: "None",
        value: "None"
    },
    {
        label: "Pregnant past first trimester",
        value: "Pregnant past first trimester"
    },
    {
        label: "Accompanying children/derivatives",
        value: "Accompanying children/derivatives"
    }
];

export const numberOfChildren: any = [
    {
        label: "1",
        value: "1"
    },
    {
        label: "2",
        value: "2"
    },
    {
        label: "3",
        value: "3"
    },
    {
        label: "4",
        value: "4"
    },
    {
        label: "5",
        value: "5"
    },
    {
        label: "6",
        value: "6"
    },
    {
        label: "More than 6",
        value: "7"
    }
];

export const ageOfChildren: any = [
    {
        label: "0-1",
        value: "0-1"
    },
    {
        label: "1-3",
        value: "1-3"
    },
    {
        label: "3-15",
        value: "3-15"
    },
    {
        label: "Over 16",
        value: "Over 16"
    }
];

export const historyOfViolence: any = [
    {
        label: "None",
        value: "None"
    },
    {
        label: "History of violent behavior",
        value: "History of violent behavior"
    },
    {
        label: "History of aggression",
        value: "History of aggression"
    },
    {
        label: "Current state of inflicting self-injury",
        value: "Current state of inflicting self-injury"
    },
    {
        label: "Current suicidal ideation",
        value: "Current suicidal ideation"
    },
    {
        label: "Previous suicide attempt(s)",
        value: "Previous suicide attempt(s)"
    },
    {
        label: "Perpetrator of sexual abuse/violence",
        value: "Perpetrator of sexual abuse/violence"
    }
];

export const currentMentalHealth: any = [
    {
        label: "None Disclosed",
        value: "None Disclosed"
    },
    {
        label: "Did not ask",
        value: "Did not ask"
    },
    {
        label: "Yes, mental health diagnosis with no prescribed medication",
        value: "Yes, mental health diagnosis with no prescribed medication"
    },
    {
        label: "Yes, compliant with medication for mental health diagnosis",
        value: "Yes, compliant with medication for mental health diagnosis"
    },
    {
        label: "Yes, noncompliant with medication for mental health diagnosis",
        value: "Yes, noncompliant with medication for mental health diagnosis"
    }
];

export const currentSubstanceUse: any = [
    {
        label: "None",
        value: "None"
    },
    {
        label: "Unsure",
        value: "Unsure"
    },
    {
        label: "Yes, while in trafficking situation",
        value: "Yes, while in trafficking situation"
    },
    {
        label: "Yes, recreationally",
        value: "Yes, recreationally"
    },
    {
        label: "Yes, substance use disorder as defined by the DSM-5 (use, intoxication or withdrawal)",
        value: "Yes, substance use disorder as defined by the DSM-5 (use, intoxication or withdrawal)"
    }
];

export const englishProficiency: any = [
    {
        label: "Limited",
        value: "Limited"
    },
    {
        label: "Basic",
        value: "Basic"
    },
    {
        label: "Proficient",
        value: "Proficient"
    }
];

export const traffickingSituation: any = [
    {
        label: "Labor trafficking",
        value: "Labor trafficking"
    },
    {
        label: "Sex trafficking",
        value: "Sex trafficking"
    },
    {
        label: "Domestic violence",
        value: "Domestic violence"
    },
    {
        label: "Sexual assault",
        value: "Sexual assault"
    },
    {
        label: "Runaway and/or homeless youth",
        value: "Runaway and/or homeless youth"
    }
];

export const physicalDisability: any = [
    {
        label: "None",
        value: "None"
    },
    {
        label: "Needs elevator and ramp access",
        value: "Needs elevator and ramp access"
    },
    {
        label: "Has visual disabilities",
        value: "Has visual disabilities"
    },
    {
        label: "Has hearing disabilities",
        value: "Has hearing disabilities"
    },
    {
        label: "Accompanied by a service animal",
        value: "Accompanied by a service animal"
    },
    {
        label: "Other",
        value: "Other"
    }
];

export const currentHousingSituation: any = [
    {
        label: "Runaway",
        value: "Runaway"
    },
    {
        label: "Homeless",
        value: "Homeless"
    }
];

export const languageSpoken: any = [
    {
        label: "English",
        value: "English"
    },
    {
        label: "Spanish",
        value: "Spanish"
    },
    {
        label: "ASL",
        value: "ASL"
    },
    {
        label: "Mandarin",
        value: "Mandarin"
    },
    {
        label: "Arabic",
        value: "Arabic"
    },
    {
        label: "Japanese",
        value: "Japanese"
    },
    {
        label: "Other",
        value: "Other"
    }
];
